
export default {
  layout: 'blank',
  data: function () {
    return {
      methodLoginValue: '',
      isAuthorised: false
    }
  },

  computed: {
    redirectPath() {
      const path = this.$route.query.previousPath
      return path || this.localePath('/')
    }
  },

  mounted() {
    this.isAuthorised = this.$passwordProtect.isAuthorised()
  },

  methods: {
    loginUser() {
      this.$passwordProtect.authorise(this.methodLoginValue)
      this.isAuthorised = this.$passwordProtect.isAuthorised()

      this.$router.push(this.redirectPath)
    },
    removeAuthorisation() {
      this.$passwordProtect.removeAuthorisation()
      this.isAuthorised = this.$passwordProtect.isAuthorised()
    }
  }
}
